module.exports = __webpack_public_path__ + "static/media/International_travel_controls_delay.fceae792.svg";